import { render, staticRenderFns } from "./SetCountry.vue?vue&type=template&id=6fbac52d"
import script from "./SetCountry.vue?vue&type=script&lang=js"
export * from "./SetCountry.vue?vue&type=script&lang=js"
import style0 from "./SetCountry.vue?vue&type=style&index=0&id=6fbac52d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports